var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Logger Module","items":_vm.logNames},model:{value:(_vm.moduleToConfigure),callback:function ($$v) {_vm.moduleToConfigure=$$v},expression:"moduleToConfigure"}})}
var staticRenderFns = []

export { render, staticRenderFns }